"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialDataMiddleware = void 0;
var _react = require("react");
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- okay in this case as value can be generic */ var initialDataMiddleware = function(useSWRNext) {
    return function(key, fetcher, config) {
        var hasMounted = (0, _react.useRef)(false);
        var _config_revalidateOnMount;
        var fallbackConfig = _object_spread_props(_object_spread({}, config), {
            fallbackData: hasMounted.current ? undefined : config.fallbackData,
            revalidateOnMount: (_config_revalidateOnMount = config.revalidateOnMount) !== null && _config_revalidateOnMount !== void 0 ? _config_revalidateOnMount : !config.fallbackData
        });
        var swr = useSWRNext(key, fetcher, fallbackConfig);
        var mutate = swr.mutate;
        (0, _react.useEffect)(function() {
            if (config.fallbackData && !hasMounted.current) {
                // Populate the cache with the initial data
                mutate(config.fallbackData, false);
            }
        }, [
            mutate,
            config.fallbackData,
            key
        ]);
        (0, _react.useEffect)(function() {
            hasMounted.current = true;
            return function() {
                hasMounted.current = false;
            };
        }, []);
        return swr;
    };
};
exports.initialDataMiddleware = initialDataMiddleware; //# sourceMappingURL=initialDataMiddleware.js.map
